(() => {
  'use strict';
  if (window.UniProductPrefetch || window.Shopify?.designMode || window.top !== window ||
    !window.HTMLScriptElement?.supports?.('speculationrules') || typeof window.requestIdleCallback !== 'function') return;
  if (window.Shopify?.previewMode === true && (!window.UniThemePreview?.id ||
    String(window.UniThemePreview.id) !== String(window.Shopify.theme?.id || ''))) return;
  window.UniProductPrefetch = {};
  const used = new Set();
  const connection = navigator.connection;
  const nonce = document.currentScript?.nonce;
  const allowedParams = new Set(['variant', 'preview_theme_id', 'uni_preview']);
  let timer, idle, paused = false, listening = false;

  function allowed() {
    return !paused && used.size < 2 && document.visibilityState === 'visible' && !document.prerendering &&
      !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType) &&
      !(typeof connection?.downlink === 'number' && connection.downlink < 1);
  }

  function visible(link) {
    if (!link.isConnected || !link.getClientRects().length || link.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    const box = link.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 &&
      box.top < window.innerHeight && box.left < window.innerWidth;
  }

  function safeURL(input) {
    let url;
    try { url = new URL(input, location.href); } catch { return null; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password ||
      !/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) return null;
    for (const key of url.searchParams.keys()) {
      if (!allowedParams.has(key) || url.searchParams.getAll(key).length !== 1 || !/^\d+$/.test(url.searchParams.get(key))) return null;
    }
    const theme = String(window.UniThemePreview?.id || window.Shopify?.theme?.id || '');
    for (const key of ['preview_theme_id', 'uni_preview']) {
      if (url.searchParams.has(key) && url.searchParams.get(key) !== theme) return null;
    }
    url.hash = '';
    return url;
  }

  function target(link) {
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return null;
    const original = safeURL(link.href);
    if (!original) return null;
    const url = safeURL(window.UniThemePreview?.url(original.href) || original.href);
    return url?.href || null;
  }

  function collect() {
    const links = [...document.querySelectorAll('.uni-mobile-card .uni-card-image[href]')].filter(visible);
    if (!links.length || links.some(link => {
      const image = link.querySelector('img');
      return link.querySelector('template[data-uni-deferred-image]') || (image && (!image.complete || !image.naturalWidth));
    })) return [];
    const urls = new Set();
    for (const link of links) {
      if (!link.querySelector('img')) continue;
      const url = target(link);
      if (url && !used.has(url)) urls.add(url);
      if (urls.size >= 2 - used.size) break;
    }
    return [...urls];
  }

  function cancel() {
    window.clearTimeout(timer);
    if (idle !== undefined) window.cancelIdleCallback(idle);
    timer = idle = undefined;
  }

  function prefetch() {
    idle = undefined;
    if (!allowed()) return;
    const urls = collect();
    if (!urls.length) return;
    const script = document.createElement('script');
    script.type = 'speculationrules';
    script.dataset.uniProductPrefetch = '';
    if (nonce) script.nonce = nonce;
    script.textContent = JSON.stringify({ tag: 'uni_visible_products', prefetch: [{ source: 'list', urls, eagerness: 'immediate' }] });
    urls.forEach(url => used.add(url));
    document.head.append(script);
    if (used.size >= 2) listen(false);
  }

  function schedule() {
    cancel();
    if (!allowed()) return;
    timer = window.setTimeout(() => {
      timer = undefined;
      if (allowed() && collect().length) idle = window.requestIdleCallback(prefetch, { timeout: 1000 });
    }, 180);
  }

  function imageLoaded(event) { if (event.target?.tagName === 'IMG') schedule(); }
  function listen(on) {
    if (listening === on) return;
    listening = on;
    const method = on ? 'addEventListener' : 'removeEventListener';
    document[method]('load', imageLoaded, true);
    document[method]('visibilitychange', schedule);
    window[method]('load', schedule);
    window[method]('scroll', schedule, { passive: true });
    window[method]('resize', schedule, { passive: true });
    connection?.[method]?.('change', schedule);
  }

  window.addEventListener('pagehide', () => {
    paused = true;
    cancel();
    listen(false);
  });
  window.addEventListener('pageshow', () => {
    paused = false;
    listen(used.size < 2);
    schedule();
  });
  listen(true);
  schedule();
})();
